import { css } from "@emotion/react";
var HeaderIconStyles = function(param) {
    var theme = param.theme;
    return /*#__PURE__*/ css("fill:", theme.color.primary, ";width:", theme.spacing[50], ";height:", theme.spacing[50], ";");
};
export { HeaderIconStyles };
